import React from "react";
import "./TopCities.css"; // Import the custom CSS file

const cities = [
  { name: "Houston", image: require("../Assests/build-img-1.jpg") },
  { name: "Austin", image: require("../Assests/build-img-2.jpg") },
  { name: "Dallas", image: require("../Assests/build-img-3.jpg") },
  { name: "San Antonio", image: require("../Assests/build-img-4.jpg") },
];

const TopCities = () => {
  return (
    <div className="top-cities-container">
      {/* Title & Button Section */}
      <h2 className="top-title">
        These top Destinations are Just a ✈️ click away!
      </h2>
      <div className="top-header">
        <h3 className="top-cities-text">Top Cities</h3>
        <button className="discover-btn">Discover all Cities</button>
      </div>

      {/* City Cards Section */}
      <div className="cities-grid">
        {cities.map((city, index) => (
          <div
            key={index}
            className={`city-card ${index % 2 === 0 ? "rounded-left" : "rounded-right"}`}
          >
            <img src={city.image} alt={city.name} className="city-image" />
            <div className="city-overlay">
              <h4 className="city-name">{city.name}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopCities;
